import ImportedProjectSuiteView from 'ImportedProjectSuite/views/ImportedProjectSuiteView';

export default ImportedProjectSuiteView;
